/**
 * @description MultiSelectBoxOption component
 * @file
 * @copyright © Copyright IBI Group., created 2019. All use, disclosure, and/or reproduction of this material is prohibited unless authorized in writing. All rights reserved.
 * @module components/MultiSelectBoxOption
 */

import React from 'react';
import PropTypes from 'prop-types';

import CONSTANTS from "../config/Constants";

/**
 * @description The MultiSelectBoxOption component.
 * @param {Object} props - The props object.
 * @returns The JSX representation of the React elemnts to render.
 */
function MultiSelectBoxOption(props) {
    
    return (
        <label>
            <button type="button" onClick={handleToggleOption} aria-label="Select option">
                <span className="material-icons">
                    {props.isSelected === true || props.isSelected > CONSTANTS.ROUTE_SELECTION_STATE.partial
                        ? 'check_box'
                        : props.isSelected === false || props.isSelected < CONSTANTS.ROUTE_SELECTION_STATE.partial
                        ? 'check_box_outline_blank'
                        : 'indeterminate_check_box'}
                </span>
            </button>
            <span>{props.name}</span>
        </label>
    );

    /**
     * @description handles the toggling of the option.
     */
    function handleToggleOption() {
        props.onToggleOption(props.value);
    }
}

MultiSelectBoxOption.defaultProps = {
    name: '',
    id: '',
    isSelected: CONSTANTS.ROUTE_SELECTION_STATE.unselected,
    onToggleOption: () => null
};

MultiSelectBoxOption.propTypes = {
    name: PropTypes.string.isRequired,
    value: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number
    ]),
    isSelected: PropTypes.oneOfType([
        PropTypes.bool,
        PropTypes.number
    ]),
    onToggleOption: PropTypes.func.isRequired
};

export default MultiSelectBoxOption;
